
import i18n from "i18next";

export const getLabelRole = (roles:Array<any>) => {
    const labels = roles.map((role) => role.name);
    return labels.join(", ");
};

export const fallback = (v?: string | null) => (v && String(v).trim() !== "" ? v : "—");

export const getLabelPaymentMethod = (name:string) => {
   switch (name) {
    case "Espèces":
        return i18n.t("paymentMethod.type.cash") ;
    case "Chèque":
        return i18n.t("paymentMethod.type.check") ;
    case "Virement bancaire":
        return i18n.t("paymentMethod.type.bank") ;
    default:
        return "Unknown";
   }
};

export const getLabelPaymentMethodByType = (type:string) => {
   switch (type) {
    case "cash":
        return i18n.t("paymentMethod.type.cash") ;
    case "bank_check":
        return i18n.t("paymentMethod.type.check") ;
    case "bank_transfer":
        return i18n.t("paymentMethod.type.bank") ;
    default:
        return i18n.t("unknown");
   }
};